import { Weapon } from '@/utilities/interfaces';

const weapons: Weapon[] = [
  {
    id: 0,
    name: 'Sword of Beginnings',
    itemType: 0,
    type: 0,
    image: 'weapons/sword_001.png',
    attack: {
      min: 100,
      max: 200,
    },
    description: `Every adventurer has a beginning. This sword will get you started.`,
  },
  {
    id: 1,
    name: 'Greatsword of Beginnings',
    itemType: 0,
    type: 1,
    image: 'weapons/greatsword_001.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This greatsword will get you started.`,
  },
  {
    id: 2,
    name: 'Staff of Beginnings',
    itemType: 0,
    type: 2,
    image: 'weapons/staff_001.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This staff will get you started.`,
  },
  {
    id: 3,
    name: 'Sword of Adventurers',
    itemType: 0,
    type: 0,
    image: 'weapons/sword_002.png',
    attack: {
      min: 100,
      max: 200,
    },
    description: `Every adventurer has a beginning. This sword will get you started.`,
  },
  {
    id: 4,
    name: 'Greatsword of Adventurers',
    itemType: 0,
    type: 1,
    image: 'weapons/greatsword_002.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This greatsword will get you started.`,
  },
  {
    id: 5,
    name: 'Staff of Adventurers',
    itemType: 0,
    type: 2,
    image: 'weapons/staff_002.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This staff will get you started.`,
  },
  {
    id: 6,
    name: 'Sword of Guardians',
    itemType: 0,
    type: 0,
    image: 'weapons/sword_003.png',
    attack: {
      min: 100,
      max: 200,
    },
    description: `Every adventurer has a beginning. This sword will get you started.`,
  },
  {
    id: 7,
    name: 'Greatsword of Guardians',
    itemType: 0,
    type: 1,
    image: 'weapons/greatsword_003.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This greatsword will get you started.`,
  },
  {
    id: 8,
    name: 'Staff of Guardians',
    itemType: 0,
    type: 2,
    image: 'weapons/staff_003.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This staff will get you started.`,
  },
  {
    id: 9,
    name: 'Sword of Heroes',
    itemType: 0,
    type: 0,
    image: 'weapons/sword_004.png',
    attack: {
      min: 100,
      max: 200,
    },
    description: `Every adventurer has a beginning. This sword will get you started.`,
  },
  {
    id: 10,
    name: 'Greatsword of Heroes',
    itemType: 0,
    type: 1,
    image: 'weapons/greatsword_004.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This greatsword will get you started.`,
  },
  {
    id: 11,
    name: 'Staff of Heroes',
    itemType: 0,
    type: 2,
    image: 'weapons/staff_004.png',
    attack: {
      min: 150,
      max: 250,
    },
    description: `Every adventurer has a beginning. This staff will get you started.`,
  },
];

export default weapons;
